import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  playbackError: {
    key: 'Player-playbackError',
    defaultValue: 'Não foi possível reproduzir o vídeo.',
  },
})
